function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SingaporeFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_1532",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_1532)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_1532",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_1532)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V12H24V3H0Z",
        fill: "#E31D1C"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.65127 10.9422C6.65127 10.9422 4.532 10.0898 4.532 7.78051C4.532 5.47121 6.65127 4.64638 6.65127 4.64638C5.62127 4.38562 2.88818 4.61884 2.88818 7.78051C2.88818 10.9422 5.57997 11.5384 6.65127 10.9422ZM7.19425 10.5605L7.80222 10.1935L8.42359 10.5605L8.27152 9.84428L8.77664 9.27927H8.09226L7.80222 8.6105L7.51218 9.27927L6.82664 9.30826L7.33293 9.84428L7.19425 10.5605ZM10.0119 10.1525L9.40398 10.5195L9.54265 9.80328L9.03636 9.26726L9.7219 9.23828L10.0119 8.56951L10.302 9.23828H10.9864L10.4812 9.80328L10.6333 10.5195L10.0119 10.1525ZM8.46533 7.32743L9.0733 6.9604L9.69467 7.32743L9.5426 6.6112L10.0477 6.0462H9.36334L9.0733 5.37742L8.78326 6.0462L8.09772 6.07518L8.60401 6.6112L8.46533 7.32743ZM7.02731 8.41701L6.41935 8.78404L6.55802 8.06782L6.05173 7.5318L6.73727 7.50282L7.02731 6.83404L7.31735 7.50282H8.00173L7.49661 8.06782L7.64868 8.78404L7.02731 8.41701ZM10.4382 8.75113L11.0461 8.3841L11.6675 8.75113L11.5154 8.03491L12.0205 7.4699H11.3362L11.0461 6.80113L10.7561 7.4699L10.0705 7.49888L10.5768 8.03491L10.4382 8.75113Z",
        fill: "#F1F9FF"
      })]
    })]
  })]
}));
//# sourceMappingURL=Singapore.js.map